import { render } from "./index.vue?vue&type=template&id=5e784fe2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5e784fe2&lang=scss&scope=true"

import exportComponent from "D:\\1_frontend\\course-center\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__